export default {
      id: "flex-alignItems-stretch-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignItems-stretch-usage",
      toString: function () {
        return this.url;
      }
    }